// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__27Jp5","selected":"Chip_selected__3HvYl"};